import Axios from "axios";
import { getUserToken } from "../helpers/helpers";
import { getAPIUrl } from "./config";

export const getAxiosClient = () => {
    const token = getUserToken();
    //console.log("TOKEN: ", token, getAPIUrl())

    return Axios.create({
        baseURL: getAPIUrl(),
        headers: {
            Authorization: token
        }
    });
}

